import { companiaSeguro, companiaSeguroForm, companiaSeguroRequest } from "../models/companiaSeguro";
import { actualizarCompaniaService, crearCompaniaService } from "../service/servicesCompaniaSeguro";
import Mapper from "../../../../utils/mapper";
import Export from "../../../../utils/exportExcel";
import { format } from "rut.js";
import { getCurrentUsername } from "../../../../services/userRolesService";

export function useCompania() {

    const save = async (data: companiaSeguroForm, dataediting: companiaSeguro | undefined) => {
        const currentUsername = getCurrentUsername();

        let dataRequest: companiaSeguroRequest = {
            nombre: data.nombre,
            rut: format(data.rut, { dots: false }),
            id: 0,
            activo: true,
            creadoPor: currentUsername,
            modificadoPor: null
        };

        if (dataediting) {
            dataRequest.id = dataediting.id;
            dataRequest.activo = dataediting.activo;
            dataRequest.modificadoPor = currentUsername;
            dataRequest.creadoPor = dataediting.creadoPor;

            return await actualizarCompaniaService(dataRequest);
        }

        return await crearCompaniaService(dataRequest);
    }

    function exportExcelOld(data: companiaSeguro[]) {
        const headers = [
            [
                'Nombre',
                'Rut',
                'Estado'
            ],
        ]
        const dataExport = data.map((row: companiaSeguro) => ({
            'Nombre': row.nombre,
            'Rut': row.rut,
            'Estado': row.activo ? 'Activo' : 'Inactivo'
        }));

        return Export({
            dataSource: dataExport,
            fileName: Mapper.ToNombreArchivoExport('COMPANIAS'),
            headers: headers,
        })
    }

    return {
        save,
        exportExcelOld
    }
}
